import axios from "axios";
import API_URL from "../config/apiConfig";

const restaurantHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const changeOrderStatus = (orderId, status) =>
  axios
    .patch(`${API_URL}/api/orders/${orderId}/status`, { status }, { headers: restaurantHeaders() })
    .then(({ data }) => data.order);
